import { Component, Story, Knobs } from './DocTypes';

const BasicStoryKnobs: Knobs = {
  heading: { default: 'Simple Popover', editor: 'textbox' },
  initialHeight: { default: '300px', editor: 'textbox', delimiter: '\n  ' },
  'colour-scheme': {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', ''],
    default: '',
  },
};

const BasicStory: Story = {
  title: 'Basic',
  description: 'A basic modal for mobile apps',

  coreComponent_v3: {
    html: `
<tag3-mobile-slider-popover {{...knobs}}>
  <div style="padding: 5px 20px;font-size: 15px;">
    <p style="font-size: 15px;">A popover panel that can be maximised.</p>
    <p style="font-size: 15px;">Drag up to maximise, or quickly drag up.</p>
    <p style="font-size: 15px;">Drag down to close, or quickly drag down.</p>
    <p>
      <tag3-simple-button data-name='close' size='small' device='mobile'>Dismiss Popover</tag3-simple-button>
    </p>
  </div>
</tag3-mobile-slider-popover>
<div style="padding: 16px;">
  <tag3-simple-button data-name='open' {{colour-scheme}}>Open</tag3-simple-button>
</div>
`,
    js: `var openButton = document.querySelector('tag3-simple-button[data-name="open"]');
openButton.addEventListener("buttonClick", function () {
  var modal = document.querySelector('tag3-mobile-slider-popover');
  modal.open = true;
});

var closeButton = document.querySelector('tag3-simple-button[data-name="close"]');
closeButton.addEventListener("buttonClick", function () {
  var modal = document.querySelector('tag3-mobile-slider-popover');
  modal.open = false;
});
`,
    knobs: BasicStoryKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <TagMobileSliderPopover open={open} {{...knobs}} onClosed={() => setOpen(false)}>
        <div style={{padding: "5px 20px", fontSize: "15px"}}>
          <p style={{fontSize: "15px"}}>A popover panel that can be maximised.</p>
          <p style={{fontSize: "15px"}}>Drag up to maximise, or quickly drag up.</p>
          <p style={{fontSize: "15px"}}>Drag down to close, or quickly drag down.</p>
          <p>
            <Tag3Button size='small' device='mobile' onButtonClick={() => setOpen(false)}>Dismiss Popover</Tag3Button>
          </p>
        </div>
      </TagMobileSliderPopover>
      <div style={{padding: "16px" }}>
        <Tag3SimpleButton
          onButtonClick={() => setOpen(true)}
        {{colour-scheme}}>
          Open
        </Tag3SimpleButton>
      </div>
    </>
  )
}
`,
    knobs: BasicStoryKnobs,
  },
};

const ScrollingContentStory: Story = {
  title: 'Scrolling Content',
  description: 'A basic modal with scrolling content for mobile apps',

  coreComponent_v3: {
    html: `
<tag3-mobile-slider-popover {{...knobs}}>
  <div style="padding: 5px 20px;font-size: 15px;">
    <ul>
      <li>Breanna Daniell</li>
      <li>Esther Boatwright</li>
      <li>Skylar Ingram</li>
      <li>Zaiden Eaton</li>
      <li>Fleurette Oliverson</li>
      <li>Lee Ansel</li>
      <li>Bennett Willey</li>
      <li>Lexy Ayers</li>
      <li>Laurie Whinery</li>
      <li>Jace Wade</li>
    </ul>
  </div>
</tag3-mobile-slider-popover>
<div style="padding: 16px;">
  <tag3-simple-button data-name='open' {{colour-scheme}}>Open</tag3-simple-button>
</div>
`,
    js: `var openButton = document.querySelector('tag3-simple-button[data-name="open"]');
openButton.addEventListener("buttonClick", function () {
  var modal = document.querySelector('tag3-mobile-slider-popover');
  modal.open = true;
});
`,
    knobs: BasicStoryKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <TagMobileSliderPopover open={open} {{...knobs}} onClosed={() => setOpen(false)}>
        <div style={{padding: "5px 20px", fontSize: "15px"}}>
          <ul>
            <li>Breanna Daniell</li>
            <li>Esther Boatwright</li>
            <li>Skylar Ingram</li>
            <li>Zaiden Eaton</li>
            <li>Fleurette Oliverson</li>
            <li>Lee Ansel</li>
            <li>Bennett Willey</li>
            <li>Lexy Ayers</li>
            <li>Laurie Whinery</li>
            <li>Jace Wade</li>
            <li>Jillian Swift</li>
            <li>Norbert Firmin</li>
            <li>Gene Matthewson</li>
            <li>Lessie Royceston</li>
            <li>Archibald Christophers</li>
            <li>Annmarie Warren</li>
            <li>Wilbur Alger</li>
            <li>Misti Tate</li>
            <li>Elly Park</li>
            <li>Esme Hampton</li>
          </ul>
        </div>
      </TagMobileSliderPopover>
      <div style={{padding: "16px" }}>
        <Tag3SimpleButton
          onButtonClick={() => setOpen(true)}
        {{colour-scheme}}>
          Open
        </Tag3SimpleButton>
      </div>
    </>
  )
}
`,
    knobs: BasicStoryKnobs,
  },
};

export const TagMobileSliderPopoverDocs: Component = {
  type: 'component',
  name: 'mobile-slider-popover',
  description: 'Renders a popover that the user can slide up and down.',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'height',
      description: 'total expandable height of the slider',
      type: 'string',
      default: '200px',
    },
    {
      name: 'width',
      description: 'slider width',
      type: 'string',
      default: '200px',
    },
    {
      name: 'minHeight',
      description: 'minimum slider height (including header)',
      type: 'string',
      default: '50px',
    },
    {
      name: 'colour-scheme',
      description:
        'Dark mode (theme) control. Undefined for normal browser control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light',
    },
    {
      name: 'device',
      description: 'Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'mobile',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'closed',
      description: 'Raised when the popover closed',
      parameters: [],
    },
  ],
  methods: [],
  stories: [BasicStory, ScrollingContentStory],
};
